import classNames from 'classnames';
import { noop } from 'lodash-es';
import { FormattedMessage, useIntl } from 'react-intl';

import { FAIcon } from '../adapters/fontAwesomeAdapters';
import { ThreeDotsSpinner } from '../data/Spinner';
import { useIconButtonStyles } from './IconButton.styles';

export default function IconButton({
  className,
  disabled,
  active,
  icon,
  type,
  label,
  labelId,
  loading,
  title,
  titleId,
  children,
  onClick,
  style,
  size,
  ...rest
}) {
  const intl = useIntl();
  const { styles } = useIconButtonStyles();

  return (
    <div
      className={classNames(
        'IconButton',
        styles.iconButton,
        {
          active,
          disabled,
          loading,
          [styles.iconButtonHasLabel]: label || labelId || children,
        },
        size && `size-${size}`,
        className
      )}
      onClick={disabled || loading ? noop : onClick}
      style={style}
      title={titleId ? intl.formatMessage({ id: titleId }) : title}
      {...rest}
    >
      <div className="IconButton-Icon">
        <FAIcon icon={icon} type={type} />
      </div>
      <div className="IconButton-Label">
        {labelId ? <FormattedMessage id={labelId} /> : label}
        {children}
      </div>
      {loading && <ThreeDotsSpinner />}
    </div>
  );
}
